import { useSelector } from "react-redux";
import { useLocation } from "react-router";
import { BulkActionsGenerator } from "shared/components/BulkActionsGenerator";
import { BulkUpdateGroups } from "shared/dropdowns/library-dropdown/group/bulk-update-groups";
import { BulkUnlinkPersonas } from "shared/dropdowns/library-dropdown/persona/bulk-unlink-personas";
import { BulkUpdateTags } from "shared/dropdowns/library-dropdown/tags/bulk-update-tags";
import BulkModalLinkComponent from "shared/modals/bulk-links/BulkModalLinkComponent";
import { ActionConfirmModal } from "shared/modals/index";
import { useModal } from "use-modal-hook";
import { getCxAttribute } from "utils/helpers";
import { InformationType } from "utils/optionsSets/OptionSets";
import { archiveManyOpportunities, bulkUnlinkOpportunityRecords, deleteManyOpportunities, deleteManyOpportunitiesPermanently, restoreManyOpportunities } from "../reducer/OpportunityActions";

export const BulkActions = (selectedOpps, setSelected, onSuccess, setDisableBulkActions) => {
	const pathname = useLocation().pathname;
	const isTrash = pathname === "/trash";
	const isArchive = pathname === "/archive";

	const actions = [];
	const subscriptionPlan = useSelector((state) => state.auth?.userInfo?.UserSubscriptionPlanName);
	const selectedItemsIdsStr = selectedOpps.map((item) => item?.id).join("|");
	const isSubscriptionAllowed = ["SharedExpert", "Expert", "SharedEnterprise", "Enterprise"].includes(subscriptionPlan);

	const tagCxAttributes = selectedOpps?.map((record) => getCxAttribute({ data: record, informationType: InformationType.Tags }));
	const groupCxAttributes = selectedOpps?.map((record) => getCxAttribute({ data: record, informationType: InformationType.Group }));

	const [showModalArchivePopup] = useModal(ActionConfirmModal, {
		bodyContent: "ARCHIVE_MANY",
		Action: () => {
			setDisableBulkActions(true);
			archiveManyOpportunities({ ids: selectedItemsIdsStr, displayToast: "BULK_ARCHIVE_SUCCESS", onSuccess });
		},
		actionBtnText: "ARCHIVE",
	});

	const [showModalDeletePopup] = useModal(ActionConfirmModal, {
		bodyContent: "DELETE_MANY",
		Action: () => {
			setDisableBulkActions(true);
			deleteManyOpportunities({ ids: selectedItemsIdsStr, displayToast: "BULK_DELETE_SUCCESS", onSuccess });
		},
		actionBtnText: "ASPX_13",
	});

	const [showModalDeletePermanentPopup] = useModal(ActionConfirmModal, {
		bodyContent: "DELETE_MANY_PERMANENT",
		Action: () => {
			setDisableBulkActions(true);
			deleteManyOpportunitiesPermanently({ ids: selectedItemsIdsStr, displayToast: "BULK_DELETE_SUCCESS", onSuccess });
		},
		actionBtnText: "ASPX_13",
	});

	const [showBulkModalLinkComponent] = useModal(BulkModalLinkComponent);
	const unlinkPersona = (personaToUnlinkId) =>
		bulkUnlinkOpportunityRecords({ recEntityName: "cem_persona", recIds: [personaToUnlinkId], ids: selectedItemsIdsStr.split("|"), attribute: "linkedPersonas" });

	if (isTrash || isArchive) {
		actions.push({ handleClick: () => restoreManyOpportunities({ ids: selectedItemsIdsStr, displayToast: "RESTORE", onSuccess }), icon: "RESTORE", description: "JS_96" });
		actions.push({ handleClick: isArchive ? showModalDeletePopup : showModalDeletePermanentPopup, icon: "DELETE", description: isArchive ? "ASPX_13" : "JS_97" });
	} else {
		actions.push({ handleClick: () => showBulkModalLinkComponent({ componentName: "folder", idAttribute: "id" }), icon: "FOLDER-OPEN", description: "MOVE_TO_FOLDER" });
		if (isSubscriptionAllowed) actions.push({ handleClick: showModalArchivePopup, icon: "ARCHIVE", description: "ARCHIVE" });
		actions.push({ handleClick: showModalDeletePopup, icon: "DELETE", description: "ASPX_13" });

		actions.push({
			renderCustomComponent: () => <BulkUnlinkPersonas allRecordsSelector="opportunity.all_Opportunities" recordIds={selectedItemsIdsStr.split("|")} handleUnlink={unlinkPersona} />,
		});
		actions.push({
			renderCustomComponent: () => <BulkUpdateTags recordIds={tagCxAttributes?.map((att) => att?.id) || []} recordType="cem_cxattribute" />,
		});
		actions.push({
			renderCustomComponent: () => <BulkUpdateGroups recordIds={groupCxAttributes?.map((att) => att?.id) || []} recordType="cem_cxattribute" />,
		});
	}

	return <BulkActionsGenerator actions={actions} setSelected={setSelected} warningText={"BULK_ACTIONS_MAP_OWNER_ONLY"} />;
};
